//namespace Pacem.Drawing3D.WebGPU {
export const LABEL_PREFIX = 'pacem-3d-';
export const U32_MAX = 4_294_967_295;
// #region vertex state
export const VERTEX_BUFFER_INDEX_MESH_POSITION = 0;
export const VERTEX_BUFFER_INDEX_MESH_NORMAL = 1;
export const VERTEX_BUFFER_INDEX_MESH_UV = 2;
export const VERTEX_OUTPUT_LOCATION_NORMAL = 0;
export const VERTEX_OUTPUT_LOCATION_VERTEX = 1;
export const VERTEX_OUTPUT_LOCATION_UV = 2;
export const VERTEX_OUTPUT_LOCATION_INDEX = 3;
export const VERTEX_OUTPUT_LOCATION_RAY = 4;
export const VERTEX_OUTPUT_LOCATION_INSTANCE = 5;
export const UNIFORM_GROUP_INDEX_TRANSFORM = 1;
export const UNIFORM_GROUP_INDEX_CAMERA = 0;
export const UNIFORM_GROUP_INDEX_INTERACTION = UNIFORM_GROUP_INDEX_CAMERA; // put it in camera same binding group
export const STORAGE_GROUP_INDEX_LINE = 2;
export const UNIFORM_GROUP_INDEX_COLORPICKING = 2;
export const UNIFORM_BINDING_INDEX_TRANSFORM = 0;
export const UNIFORM_BINDING_INDEX_CAMERA = 0;
export const UNIFORM_BINDING_INDEX_INTERACTION = 1;
// #endregion
// #region fragment state
export const MATERIAL_GROUP_INDEX = 2;
export const UNIFORM_GROUP_INDEX_LIGHTING = MATERIAL_GROUP_INDEX + 1;
export const STORAGE_MATERIAL_INDEX = 0;
export const SAMPLER_BINDING_INDEX = 1;
export const TEXTURE_BINDING_INDEX = 2;
export const MATERIAL_REFERENCE = 'material';
export const VERTEX_COLOR_REFERENCE = 'color';
export const AMBIENT_COLOR_REFERENCE = 'ambient';
export const LIGHTING_COLOR_REFERENCE = 'lighting';
// #endregion
// #region WGSL
export const WGSL_VERTEXINPUT_STRUCT_NAME = 'VertexInput';
export const WGSL_VERTEXOUTPUT_STRUCT_NAME = 'VertexOutput';
export const WGSL_INTERACTIONDATA_STRUCT_NAME = 'InteractionData';
// #endregion
// Kinda polyfill for WebGPU constants, as TypeScript 6.0 does include WebGPU types but does NOT include these constants for magic numbers:
export var GPUBufferUsage;
(function (GPUBufferUsage) {
    GPUBufferUsage[GPUBufferUsage["COPY_SRC"] = 4] = "COPY_SRC";
    GPUBufferUsage[GPUBufferUsage["COPY_DST"] = 8] = "COPY_DST";
    GPUBufferUsage[GPUBufferUsage["INDEX"] = 16] = "INDEX";
    GPUBufferUsage[GPUBufferUsage["INDIRECT"] = 256] = "INDIRECT";
    GPUBufferUsage[GPUBufferUsage["MAP_READ"] = 1] = "MAP_READ";
    GPUBufferUsage[GPUBufferUsage["MAP_WRITE"] = 2] = "MAP_WRITE";
    GPUBufferUsage[GPUBufferUsage["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    GPUBufferUsage[GPUBufferUsage["STORAGE"] = 128] = "STORAGE";
    GPUBufferUsage[GPUBufferUsage["UNIFORM"] = 64] = "UNIFORM";
    GPUBufferUsage[GPUBufferUsage["VERTEX"] = 32] = "VERTEX";
})(GPUBufferUsage || (GPUBufferUsage = {}));
export var GPUTextureUsage;
(function (GPUTextureUsage) {
    GPUTextureUsage[GPUTextureUsage["COPY_SRC"] = 1] = "COPY_SRC";
    GPUTextureUsage[GPUTextureUsage["COPY_DST"] = 2] = "COPY_DST";
    GPUTextureUsage[GPUTextureUsage["RENDER_ATTACHMENT"] = 16] = "RENDER_ATTACHMENT";
    GPUTextureUsage[GPUTextureUsage["STORAGE_BINDING"] = 8] = "STORAGE_BINDING";
    GPUTextureUsage[GPUTextureUsage["TEXTURE_BINDING"] = 4] = "TEXTURE_BINDING";
})(GPUTextureUsage || (GPUTextureUsage = {}));
export var GPUShaderStage;
(function (GPUShaderStage) {
    GPUShaderStage[GPUShaderStage["VERTEX"] = 1] = "VERTEX";
    GPUShaderStage[GPUShaderStage["FRAGMENT"] = 2] = "FRAGMENT";
    GPUShaderStage[GPUShaderStage["COMPUTE"] = 4] = "COMPUTE";
})(GPUShaderStage || (GPUShaderStage = {}));
export var GPUMapMode;
(function (GPUMapMode) {
    GPUMapMode[GPUMapMode["READ"] = 1] = "READ";
    GPUMapMode[GPUMapMode["WRITE"] = 2] = "WRITE";
})(GPUMapMode || (GPUMapMode = {}));
